<script setup>
import { ref, onMounted, computed } from "vue";
import { RouterView, useRoute } from "vue-router";
import TopNav from "@/components/TopNav.vue";
import AIChat from "@/components/AIChat.vue";
import { useStore } from "@/store";
import { buildJobsStore } from "@/store/buildJobs";
import backgroundImage from "@/assets/background.png";

// Get the current route to check which page is active
const route = useRoute();

onMounted(async () => {
  // Load user data if authenticated
  if (localStorage.getItem("token")) {
    await useStore.loadUser();
  }
  // Re-attach to any installer builds that were in-flight before a reload.
  buildJobsStore.resumeAll();
});

// Computed property to determine if nav should be shown
const showNav = computed(() => route.name !== "login");
</script>

<template>
  <div id="main-layout" class="min-h-screen relative">
    <!-- Background Image with Faded Overlay -->
    <div 
      class="fixed inset-0 -z-10 bg-cover bg-center"
      :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
    ></div>
    <div class="fixed inset-0 -z-10 bg-white/40 dark:bg-gray-900/60 backdrop-blur-sm"></div>
    
    <!-- Floating Orbs for Visual Interest -->
    <div class="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      <div class="absolute top-20 left-10 w-72 h-72 bg-purple-500/10 rounded-full blur-3xl animate-float"></div>
      <div class="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-float-slow"></div>
      <div class="absolute top-1/2 left-1/3 w-64 h-64 bg-pink-500/10 rounded-full blur-3xl animate-float" style="animation-delay: 2s;"></div>
    </div>
    
    <!-- Top Navigation -->
    <TopNav v-if="showNav" />

    <!-- Main content section -->
    <main id="main-section" class="min-h-screen" :class="{ 'pt-20': showNav }">
      <RouterView />
    </main>

    <!-- AI Chat Component (only show when logged in) -->
    <!-- <AIChat v-if="showNav" /> -->
  </div>
</template>
